import compose from 'react-hooks-compose'

import { useUsuarioPageFooterLogic } from './useLogic'
import { UsuarioPageFooterPresenter } from './presenter'

export const UsuarioPageFooter = compose(props => ({
	useLogic: () => useUsuarioPageFooterLogic(props),
}))(UsuarioPageFooterPresenter)
